import initTabbedContentCarousel from "../initTabbedContentCarousel.js";

document.addEventListener("DOMContentLoaded", () => {
  initTabbedContentCarousel();
});
